import './UsersPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';

import { getUsers, sendUsersCsv } from 'containers/UsersPage/store/actions';

import A from 'components/A';
import Button from 'components/Button';
import PageContent from 'components/PageContent';
import LoadingCircle from 'components/LoadingCircle';
import ConfirmModal from "../../components/Modal/ConfirmModal";

class UsersPage extends React.Component {
    constructor() {
        super();

        this.columns = [
            {
                text: 'Is Admin',
                obj: 'user',
                name: 'isAdmin',
                noSort: true
            },{
                text: 'First Name',
                obj: 'user',
                name: 'firstName'
            }, {
                text: 'Last Name',
                obj: 'user',
                name: 'lastName'
            }, {
                text: 'Email',
                obj: 'user',
                name: 'email'
            }, {
                text: 'Created Date',
                obj: 'user',
                name: 'created_at'
            }, {
                text: 'Company',
                obj: 'company',
                name: 'name'
            }, {
                text: 'Zip Code',
                obj: 'company',
                name: 'zip'
            }, {
                text: 'City',
                obj: 'company',
                name: 'city'
            }, {
                text: 'State',
                obj: 'company',
                name: 'state'
            }, {
                text: 'Cows in Herd',
                obj: 'company',
                name: 'cowsInHerd'
            }, /*{
                text: 'Avg Production',
                obj: 'company',
                name: 'averageDailyMilkLbs'
            }, {
                text: 'Average Basis',
                obj: 'company',
                name: 'averageBasis'
            }, {
                text: 'Profitability',
                obj: 'profitability',
                name: 'total12MonthProfitability'
            }, {
                text: 'Profitability Change',
                obj: 'profitability',
                name: 'total12MonthProfitabilityNetChangeSinceYesterday'
            },*/ {
                text: 'Referral Code',
                obj: 'user',
                name: 'referralCode'
            }
        ];

        this.state = {
            atEnd: true,
            isInfiniteScrolling: false,
            sortByName: 'created_at',
            sortByObj: 'user',
            sortDirection: 'DESC',
            showConfirmModal: false,
            showSuccessModal: false
        }
    }

    componentWillMount() {
        document.body.classList.add('users-page');

        this.props.getUsers(false, this.state)
            .then((res) => {
                this.setState({atEnd: res.data.users.length === 0});
            });
    }

    componentWillUnmount() {
        document.body.classList.remove('users-page');
    }

    async handleConfirmDownload() {
        try {
            await this.props.sendUsersCsv();
            this.setState({
                showConfirmModal: false,
                showSuccessModal: true
            });
        } catch(err) {
            console.log('UsersPage handleConfirmDownload err', err);
            this.setState({ showConfirmModal: false });
        }
    }

    async handleInfiniteScroll() {
        if(this.props.users.isGettingUsers || this.state.isInfiniteScrolling || this.state.atEnd) {
            return;
        }

        try {
            this.setState({isInfiniteScrolling: true});
            let res = await this.props.getUsers(true, this.state);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: res.data.users.length === 0
            });
        } catch(err) {
            console.log('UsersPage handleInfiniteScroll err', err);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: true
            });
        }
    };

    _sortTable(obj, name, noSort) {
        if(noSort === true) {
            return;
        }

        this.setState({atEnd: true});

        let { sortByName, sortByObj, sortDirection } = this.state;

        if (sortByName === name) {
            if (sortDirection === 'ASC') {
                sortDirection = 'DESC';
            } else {
                sortDirection = 'ASC';
            }
        } else {
            sortDirection = 'ASC';
            sortByName = name;
            sortByObj = obj;
        }

        /*let sortedUsers = this._sortTableBy(this.props.users.users, sortByObj, sortByName, sortDirection);*/
        //this.props.setSortedUsers(sortedUsers);
        const filters = {sortByName, sortByObj, sortDirection};
        this.props.getUsers(false, filters)
            .then((res) => {
                this.setState({atEnd: res.data.users.length === 0});
            });
        this.setState(filters);
    }

    render() {
        return (
            <PageContent>
                <Button
                    className="download-users-csv"
                    onClick={() => this.setState({showConfirmModal: true})}
                >
                    Download CSV of All Users
                </Button>

                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.handleInfiniteScroll.bind(this)}
                    hasMore={!this.state.atEnd}
                >
                    <div className="users-table--wrapper">
                        <table className="users-table">
                            <thead>
                                <tr>
                                    {this.columns.map((col, index) => {
                                        return (
                                            <th
                                                className={classNames('users-table__heading', {
                                                    'sort-by--asc': this.state.sortByName === col.name && this.state.sortDirection === 'ASC',
                                                    'sort-by--desc': this.state.sortByName === col.name && this.state.sortDirection === 'DESC',
                                                    'no-sort': col.noSort === true
                                                })}
                                                key={index}
                                                onClick={this._sortTable.bind(this, col.obj, col.name, col.noSort)}
                                            >
                                                {col.name !== 'isAdmin' ? col.text : ''}
                                            </th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.users.sortedUsers.map((user) => {
                                    if(user.user != null && user.company != null) {
                                        return (
                                            <tr key={user.user.id}>
                                                {this.columns.map((col, index) => {
                                                    if(col.name === 'email') {
                                                        return (
                                                            <td key={index}>
                                                                <A href={`mailto:${user.user.email}`} target="_blank">{user.user.email}</A>
                                                            </td>
                                                        );
                                                    } else if(col.name === 'created_at') {
                                                        return (
                                                            <td key={index}>
                                                                {moment(user.user.created_at).format('YYYY-MM-DD')}
                                                            </td>
                                                        )
                                                    } else if(col.name === 'referralCode') {
                                                        return (
                                                            <td key={index}>
                                                                {user.user.referralCode ? user.user.referralCode.code : '--'}
                                                            </td>
                                                        )
                                                    } else if(col.name === 'isAdmin') {
                                                        return (
                                                            <td className="admin-check-cell" key={index}>
                                                                {user.user.isAdmin === true ? (
                                                                    <svg className="admin-check" viewBox="0 0 28 28">
                                                                        <path d="M26.109 8.844c0 0.391-0.156 0.781-0.438 1.062l-13.438 13.438c-0.281 0.281-0.672 0.438-1.062 0.438s-0.781-0.156-1.062-0.438l-7.781-7.781c-0.281-0.281-0.438-0.672-0.438-1.062s0.156-0.781 0.438-1.062l2.125-2.125c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l4.594 4.609 10.25-10.266c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l2.125 2.125c0.281 0.281 0.438 0.672 0.438 1.062z" />
                                                                    </svg>
                                                                ) : ''}
                                                            </td>
                                                        )
                                                    } else {
                                                        return (
                                                            <td key={index}>
                                                                {user[col.obj][col.name] || '--'}
                                                            </td>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {this.props.users.isFetching === true && (
                                    <tr>
                                        <td colSpan={10}>
                                            <div className="users-table__loading-circle">
                                                <LoadingCircle />
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="admin-check-instructions">
                            <svg className="admin-check" viewBox="0 0 28 28">
                                <path d="M26.109 8.844c0 0.391-0.156 0.781-0.438 1.062l-13.438 13.438c-0.281 0.281-0.672 0.438-1.062 0.438s-0.781-0.156-1.062-0.438l-7.781-7.781c-0.281-0.281-0.438-0.672-0.438-1.062s0.156-0.781 0.438-1.062l2.125-2.125c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l4.594 4.609 10.25-10.266c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l2.125 2.125c0.281 0.281 0.438 0.672 0.438 1.062z" />
                            </svg> marks an Admin User
                        </div>
                    </div>
                </InfiniteScroll>

                <ConfirmModal
                    confirmOnClick={this.handleConfirmDownload.bind(this)}
                    confirmText="OK"
                    content={this.props.auth && this.props.auth.user ? `When you click OK, we'll send an email to ${this.props.auth.user.user.email} with the data attached as a CSV file.` : ''}
                    declineOnClick={() => this.setState({showConfirmModal: false})}
                    declineText="Cancel"
                    show={this.state.showConfirmModal}
                    showActivityIndicator={this.props.users.isSendingUsersCsv}
                    title="Confirmation"
                />

                <ConfirmModal
                    confirmOnClick={() => this.setState({showSuccessModal: false})}
                    confirmText="OK"
                    content={this.props.auth && this.props.auth.user ? `Your file is being generated and will be sent to ${this.props.auth.user.user.email} when completed.` : ''}
                    show={this.state.showSuccessModal}
                    title="Success!"
                />
            </PageContent>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        users: state.users
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (isUpdate, filters) => dispatch(getUsers(isUpdate, filters)),
        sendUsersCsv: () => dispatch(sendUsersCsv())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/index.js